import React from 'react';
import { OrderRulesWrapper } from './OrderRules.styled';
export const OrderRules = () => {
	return <OrderRulesWrapper>
		<span>
			Совершая оплату я соглашаюсь с <a target="_blank" href={process.env.PUBLIC_URL + '/Соглашение_о_возмездном_оказании_услуг_на_условиях_публичной_оферты.pdf'}> Публичной Офертой</a>
		</span>
	</OrderRulesWrapper>
}
